export default "__VITE_ASSET__47e0b6ac__$_?component__"